import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../../public/environments/environment";
import { formatParams } from "../helpers/FormateArrayToParams";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  contactUs(data: any) {
    return this.http.post(`${environment.apiUrl}/contact-us`, data);
  }
  GetStatistics() {
    return this.http.get(`${environment.apiUrl}/home/statistics`);
  }
  GetTopCities() {
    return this.http.get(`${environment.apiUrl}/top-cities`);
  }
  getJobs(model: any): any {
    let Params = formatParams(model);
    return this.http.get(`${environment.apiUrl}/home/jobs${Params}`);
  }
  getDomains(data: any) {
    return this.http.get(`${environment.apiUrl}/domains`, data);
  }
  getCompanyJobs(model: any): any {
    let Params = formatParams(model);
    return this.http.get(`${environment.apiUrl}/home/jobs-shared${Params}`);
  }
  getJobDetails(model: any): any {
    let Params = formatParams(model);
    return this.http.get(`${environment.apiUrl}/home/jobs-shared/show${Params}`);
  }
}
